
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import _ from "lodash";
import ColumnGroup from "primevue/columngroup"; //optional for column grouping
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import * as Yup from "yup";

interface Estado {
  estado: string;
}

interface Buscador {
  estado?: number;
  factura?: number;
  empresaId?: number;
  fechaInicio?: Date;
  fechaTermino?: Date;
  proveedorId: number;
}

export default defineComponent({
  name: "overview",
  components: {
    DataTable,
    Column,
    ErrorMessage,
    Field,
    Form,
  },
  props: {
    proveedorId: { type: Number, required: true },
  },
  data() {
    return {
      store: useStore(),
      router: useRouter(),
    };
  },
  methods: {
    formatDate(value) {
      value = new Date(value);
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    formatCurrency(value) {
      return value.toLocaleString("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: "CLP",
      });
    },
  },
  setup(props, { emit }) {
    const id = ref(props.proveedorId);
    const submitButton1 = ref<HTMLElement | null>(null);
    const store = useStore();
    const op = ref();
    const estados = ref<Array<Estado>>();
    onMounted(() => {
      setCurrentPageBreadcrumbs("Mis Facturas", ["Página", "Dashboard"]);
      store
        .dispatch(Actions.GET_EMPRESAS)
        .then()
        .catch(() => {
          const [error] = Object.keys(store.getters.getEmpresaErrors);
        });
      buscarFacturas(true);
    });
    const buscador = ref<Buscador>({ proveedorId: id.value });
    const buscadorValidator = Yup.object().shape({
      /*factura: Yup.number().label("Factura"),
      fechaInicio: Yup.date().nullable().default(null).label("Fecha de Inicio"),
      fechaTermino: Yup.date().nullable().default(null)
                .when("fechaInicio",
                    (fechaInicio, yup) => fechaInicio && yup.min(fechaInicio, "End time cannot be before start time")).label("Fecha de Término")*/
    });
    const buscarFacturas = (monted: boolean) => {
      //if (submitButton1.value) {
      // Activate indicator
      //submitButton1.value.setAttribute("data-kt-indicator", "on");
      if (buscador.value.factura != null) {
        buscador.value.factura = parseInt(buscador.value.factura.toString());
      }
      store
        .dispatch(Actions.GET_FACTURAS, buscador.value)
        .then(() => {
          loading.value = false;
          if (monted)
            estados.value = _.chain(store.getters.allFacturas)
              .groupBy("detalleEstado")
              .map((value, key) => ({ estado: key, facturas: value }))
              .value();
          // submitButton1.value?.removeAttribute("data-kt-indicator");
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getProveedorErrors);
        });
      //}
    };
    const comentario = ref(null);
    const empresas = computed(() => {
      return store.getters.allEmpresas;
    });
    const filters1 = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      numeroFactura: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      nombreEmpresa: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      detalleEstado: { value: null, matchMode: FilterMatchMode.IN },
      date: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      balance: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      status: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
      verified: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    const toggle = (data) => {
      comentario.value = data.comentarios;
      display.value = true;
      //op.value.toggle(event);
    };
    const display = ref(false);
    const loading = ref(true);
    return {
      filters1,
      empresas,
      buscador,
      loading,
      buscadorValidator,
      buscarFacturas,
      submitButton1,
      toggle,
      comentario,
      display,
      estados,
    };
  },
});
